module.exports = __webpack_public_path__ + "media/images/members/left-616ff856e8789ecf85d12c6a25f69373.svg";